const sortShortcuts = (shortcutsObject) => {
  const shortcutsArray = Object.entries(shortcutsObject);
  shortcutsArray.sort(([, a], [, b]) => a.order - b.order);
  const sortedShortcuts = new Map(shortcutsArray);
  return Object.fromEntries(sortedShortcuts.entries());
};

export { sortShortcuts };
